var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.37321 24H0.396429V7.97679H5.37321V24ZM2.88214 5.79107C1.29107 5.79107 0 4.47321 0 2.88214C0 2.11775 0.303653 1.38467 0.84416 0.84416C1.38467 0.303653 2.11775 0 2.88214 0C3.64653 0 4.37962 0.303653 4.92013 0.84416C5.46063 1.38467 5.76429 2.11775 5.76429 2.88214C5.76429 4.47321 4.47321 5.79107 2.88214 5.79107ZM23.9946 24H19.0286V16.2C19.0286 14.3411 18.9911 11.9571 16.4411 11.9571C13.8536 11.9571 13.4571 13.9768 13.4571 16.0661V24H8.48571V7.97679H13.2589V10.1625H13.3286C13.9929 8.90357 15.6161 7.575 18.0375 7.575C23.0732 7.575 24 10.8911 24 15.1982V24H23.9946Z",
    fill: "#0A66B0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame2);
export default __webpack_public_path__ + "static/media/Frame (2).13d669e2cfb19cc4e9322ec18f2b7ea6.svg";
export { ForwardRef as ReactComponent };